// extracted by mini-css-extract-plugin
export var content = "_od-1";
export var fullScreen = "_od-0";